import { isLoading } from '@/redux/selectors/uiSelectors';
import { FiPlay } from '@/components/react-icons/main/index.esm';
import IconV2 from '@/components/v2/IconV2';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import { getWorkflow, rerunWebhook } from '@/redux/actions/gravityActions';
import sendToast from '@/lib/sendToast';
import selectors from '@/redux/selectors/selectors';
import { useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';

const getReTriggerWebhookIconProps = (webhookTriggerOptions = {}) => {
  if (!webhookTriggerOptions.queueWebhooks) {
    return {
      disabled: true,
      title: 'This webhook cannot be re-triggered because “Wait for Workflow Completion” is set to false.'
    };
  }

  if (webhookTriggerOptions.sequenceWebhooks) {
    return {
      disabled: true,
      title: 'This webhook cannot be re-triggered because you have chosen “Only Run One at a Time.'
    };
  }

  return {
    disabled: false,
    title: 'Re-trigger this webhook'
  };
};

export const ReTriggerWebhook = ({ webhookStepId }) => {
  const workflowId = useSelector(selectors.workflowId);

  const workflowLogId = useArgSelector(selectors.query, 'logId');
  const publishedWorkflows = useSelector((state) => state.workflow.publishedWorkflows.filter((n) => n.id === workflowId && n.version !== 'draft'));
  const isRerunLoading = useArgSelector(isLoading, 'rerunWebhook');

  const webhookTriggerOptions = useMemo(() => {
    return publishedWorkflows?.[0]?.steps?.find((x) => x.id === webhookStepId)?.options;
  }, [publishedWorkflows, webhookStepId]);

  const onClick = () => {
    rerunWebhook({ workflowId, workflowLogId, webhookStepId }, (res) => {
      if (!res?.meta) {
        sendToast({ message: 'Error re-triggering webhook request', type: 'error', duration: 4000 });
        return;
      }
      sendToast({ message: 'Re-triggering webhook request...', type: 'success', duration: 4000 });
    });
  };

  useEffect(() => {
    // So we get the latest version of the workflow and updated webhookTriggerOptions
    getWorkflow({ id: workflowId, isPublished: true, workflowVersion: 'published' });
  }, []);

  if (!webhookTriggerOptions) {
    return null;
  }

  const iconProps = getReTriggerWebhookIconProps(webhookTriggerOptions);
  const isDisabled = iconProps.disabled || isRerunLoading;
  return <IconV2 disabled={isDisabled} className={`play ${isDisabled ? 'inactive' : ''}`} title={iconProps.title} onClick={onClick} icon={FiPlay} />;
};
